// extracted by mini-css-extract-plugin
export default {"tipText":"SearchTip_tipText__aXnvy"};